import { EndOwnership } from '@features/ForestOwner/EditShareOwnership/EndOwnership/EndOwnership'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'
import { z } from 'zod'

const searchSchema = z.object({
  isEstateSettlement: z.coerce.boolean().optional().default(false),
})
export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/',
)({
  component: RouteComponent,
  validateSearch: searchSchema,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-endownership.title'),
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  return <EndOwnership isEstateSettlement={search.isEstateSettlement} />
}
